<script setup>
let message = ref('찾을 수 없는 페이지 입니다.')

const props = defineProps({
  error: Object
})

console.error(props.error)
if (props.error?.statusCode === 429) {
  message = props.error.message
}
</script>

<template>
  <NuxtLayout>
    <SearchBanner />
    <div class="error_box">{{ message }}</div>
  </NuxtLayout>
</template>

<style scoped lang="scss">
.error_box {
  width: 100%;
  height: 60vh;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 24px;
  font-weight: 500;
}
</style>